$(document).ready(function () {
    $("#form-customer-login").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData()
        $(".error-login").html('')
        data.append('email', $("#login-email").val())
        data.append('password', $("#login-password").val())
        sendLoginData(data, '/login')
    })

    $("#form-recover-password").on('submit', function (e) {
        e.preventDefault();
        $("#btn-recovery").prop('disabled', true);
        let data = new FormData();
        data.append('email', $(".input-email-recover").val());
        sentData(data);
    })

    function sendLoginData(data, route) {
        $("#div_loading").addClass("loading-almadia")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(function () {
                    $("#div_loading").removeClass("loading-almadia")
                    if (response.success == "true") {

                        window.location.href = "/carrito/pagar";
                    }
                    if (response.success == "wishl") {
                        Cookies.remove('almadia_data_wl')
                        Cookies.remove('almadia_location-data-wl')

                        window.location.href = response.location;
                    }
                }, 3000)
            }, error: function (errors, xhr, status,) {
                $("#div_loading").removeClass("loading-almadia")
                var indices = errors.responseJSON.errors;
                $(".error-login").html('Email o contraseña incorrecta')
            }
        })
    }

    $("#login-email").focus(function () {
        $(".error-login").html('')
    })

    function sentData(data) {
        $.ajax({
            method: "POST",
            url: "recover-email-user",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success == "success") {
                    swal.fire({
                        title: 'Enviado',
                        text: data.msg,
                        icon: 'success',
                        confirmButtonColor: '#FF5001',
                    }).then((result) => {
                        window.location.href = window.location.origin + '/login';
                    });
                } else {
                    $("#btn-recovery").prop('disabled', false);
                    alertError(data.msg);
                }
            },
            error: function (errors, xhr, status,) {
                const indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-error-email").text(value);
                });
                $("#btn-recovery").prop('disabled', false);
            }
        })

    }

})
